import apiClient from "./apiClient";

const fileApi = {
  uploadFile: (file, client_id) => {
    return apiClient.uploadFile("/api/files/upload", file, client_id);
  },

  processFile: (client_id, session_id) => {
    return apiClient.processFile("/api/files/process", client_id, session_id);
  },

  getFiles: async (client_id) => {
    return await apiClient.get("/api/files", { client_id });
  },

  deleteFile: (data, filename) => {
    return apiClient.delete("/api/files/delete", {
      data,
      params: { filename },
    });
  },


  contrato_uploadFile: (file, client_id) => {
    return apiClient.uploadFile("/api/files/upload?sistema=contratos", file, client_id);
  },

  contrato_processFile: (client_id, session_id) => {
    return apiClient.processFile("/api/files/process?sistema=contratos", client_id, session_id);
  },

  contrato_getFiles: async (client_id) => {
    return await apiClient.get("/api/contracts");
  },

  contrato_deleteFile: (data, filename) => {
    return apiClient.delete(`/api/files/delete?filename=${filename}&sistema=contratos`);
  },
};

export default fileApi;